import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "Recibo da sessão")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "list-group list-group-flush" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "CPF", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-subtitle"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-receipt me-2" }),
  /*#__PURE__*/_createTextVNode("Visualizar recibo")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-subtitle" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import { ref } from "vue";
import {
  FileBaseUrl,
  type Appointment,
} from "@phurshell/psiapp-frontend-core/domain";
import { openFileUploader } from "@/utils/Helper";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateReceipt } from "@/composables/useAppointments";

const inputId = "receipt_file_input";


export default /*#__PURE__*/_defineComponent({
  __name: 'Receipt',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const uploading = ref(false);
const { mutateAsync: updateReceipt } = useUpdateReceipt();

function handleReceipt() {
  window.open(`${FileBaseUrl}${props.item.receipt}`, "_blank");
}

async function handleUploadFile(file: any) {
  try {
    uploading.value = true;
    await updateReceipt({ id: props.item.id, receipt: file.file });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Recibo anexado",
      msg: "Recibo foi anexado e você pode visualizar na tela de detalhes.",
    });
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
}

async function handleRemoveReceipt() {
  try {
    uploading.value = true;
    await updateReceipt({ id: props.item.id, remove_receipt: true });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Recibo removido",
      msg: "O recibo foi removido com sucesso.",
    });
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(["list-group-item d-flex justify-content-between align-items-center", { 'border-0': !_ctx.item.receipt }])
        }, [
          _hoisted_5,
          (_ctx.item.user?.document_number)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.item.user.document_number), 1))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.item.receipt)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: handleReceipt,
              class: "list-group-item d-flex justify-content-between align-items-center border-0 cursor-pointer"
            }, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Button, {
        label: _ctx.item.receipt ? ' Remover recibo' : 'Anexar recibo',
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.item.receipt ? handleRemoveReceipt() : _unref(openFileUploader)(inputId)
        )),
        outline: !!_ctx.item.receipt,
        fullWidth: "",
        leftIcon: _ctx.item.receipt ? '' : 'fa-solid fa-plus-circle',
        loading: uploading.value
      }, null, 8, ["label", "outline", "leftIcon", "loading"]),
      _createVNode(_component_FileUploader, {
        onFileUploaded: _cache[1] || (_cache[1] = ($event: any) => (handleUploadFile($event))),
        inputId: inputId,
        hiddenInput: true
      })
    ])
  ]))
}
}

})